import React from 'react';

const FixedPhoneNumber = ({ show }) => {
  return (
    <div className={`fixed__phone ${show ? 'fixed__phone--show' : ''}`}>
      <p className='fixed__phone-text'>Questions?</p>
      <a href="tel:+18002584585" className="fixed__phone-link"
      >(800) 258-4585</a>
    </div>
  )
}

export default FixedPhoneNumber;